import * as React from 'react';
import styles from './ShopUnavailable.scss';
import { t } from '~/utils/localization';

const ShopUnavailable = () => {
    return <div className={styles.wrapper}>{t('К сожалению, внутриигровой Премиум магазин недоступен в вашем регионе.')}</div>;
};

export default ShopUnavailable;
